<script setup>
import GlobalHero from '@sections/global/Hero.vue'

const emit = defineEmits(['riveLoaded'])
</script>

<template>
	<GlobalHero @rive-loaded="emit('riveLoaded', true)" :rive="{ src: 'https://cdn.papercrowns.com/website/rive/lockups/work.riv', height: 512, width: 1855 }" titleSvg="https://cdn.papercrowns.com/website/images/elements/lockups/work.svg" subtext="Send us your gargoyles.. You can keep the gold." />
</template>
